import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Gallery from '../sections/Gallery/Gallery';
import ServiceBanner from '../sections/ServiceBanner/ServiceBanner';
import Symptoms from '../sections/Symptoms/Symptoms';
import Appointment from '../sections/Appointment/Appointment';
import MetaHelmet from '../components/SEO/MetaHelmet';
import SchemaMarkup from '../components/SEO/SchemaMarkup';

const Services = () => {
    return (
        <>
            <MetaHelmet pageName="services" />
            <SchemaMarkup type="service" />
            <Navbar />
            <ServiceBanner />
            <Symptoms />
            <Gallery />
            <Appointment />
            <Footer />
        </>
    );
};

export default Services;